import { EasyModal, EasyIcon } from 'src/components'
import { AuditCheck } from './003'
import 'enasops/styles/op/003/index.less'

export default {
  auditCheck (ListTableContext: any, props: any) {
    const { LABEL, ICON, WIDTH, __RECORD__: record } = props.config
    return (
      <EasyModal
        modal={{
          title: '租户-审核',
          width: WIDTH || '55%',
          style: { minWidth: 960 },
          afterClose: () => ListTableContext?.reload()
        }}
        slot={
          <span title={LABEL}>
            <EasyIcon type={ICON} className='fz-16' />
            <span className='pd-l4'>{LABEL}</span>
          </span>
        }
      >
        <AuditCheck id={record.ID} />
      </EasyModal>
    )
  },
}